<template>
  <div class="main">
    <div class="user-banner">
      <img :src="cdnresources + '/prod/images/yueyangbao/userland.png'" alt="banner图" />
    </div>
    <div class="user-info">
      <img :src="cookieUser.headImg||deaultHeadImg" class="avatarIcon" />
      <div class="nick-phone">
        <div class="usernameText">{{ cookieUser.userName }}</div>
        <div class="usernameText phone">{{ handlePhone(cookieUser.mobilePhone) }}</div>
      </div>
      <div class="edit" v-if="!hideLingxiContent" @click="toMaterial">
        <img src="@/assets/img/user_center/editIcon.png" class="editIcon" />
        <div class="usernameText"></div>
      </div>
    </div>
    <div class="user-list">
      <div class="user-item">
        <img @click="goBlockMenu('UserOrder')" src="@/assets/wuxi/user-icon1.png" class="menuLiPng" />
        <img @click="goBlockMenu('UserPolicy')" src="@/assets/wuxi/user-icon2.png" class="menuLiPng" />
      </div>
      <div class="user-item" v-if="!hideLingxiContent">
        <img @click="goBlockMenu('HealthManual')" src="@/assets/wuxi/user-icon3.png" class="menuLiPng" />
        <img @click="goBlockMenu('ClaimNotice')" src="@/assets/wuxi/user-icon4.png" class="menuLiPng" />
      </div>
    </div>
  </div>
</template>

<script>
import { cdnresources, CustomerServiceLink } from '@/util/config'
import { SetGetAuthInfo } from '@/util/auth'
import { CHECK_MOBILE_PHONE_START } from '@/util/tools'

export default {
  name: 'UserCenter',
  data() {
    return {
      cdnresources,
      deaultHeadImg: require('@/assets/img/user_center/head-default.png'),
      cookieUser: {},
      lxfromSourceCode: '',
      hideLingxiContent: false,
    }
  },
  mounted() {
    
    this.cookieUser = SetGetAuthInfo.getInfo()
    const fromSourceCode = localStorage.getItem('fromSourceCode') || ''
    console.log(this.cookieUser,'111')
    if (!this.cookieUser.userId) {
      this.$router.push({
        name: 'UserLogin',
        query: {
          fromSourceCode
        }
      })
    }

    // 来自灵锡的 个人中心
    if (fromSourceCode == process.env.VUE_APP_LX_FROM_CODE || fromSourceCode == process.env.VUE_APP_LXGZH_FROM_CODE) {
      this.hideLingxiContent = true
    }
  },
  methods: {
    // 手机号脱敏
    handlePhone(phone) {
      if (phone) {
        return CHECK_MOBILE_PHONE_START(phone)
      }
    },
    // 跳转到个人资料
    toMaterial() {
      this.$router.push({ path: '/user-mean' })
    },
    // 跳转到 页面 
    goBlockMenu(val) {
      const { fromSourceCode } = this.$route.query
      this.$router.push({
        name: val,
        query: {
          fromSourceCode
        }
      })
    },
    // 跳转在线客服
    goConsult() {
      let rest = JSON.parse(localStorage.getItem('wxinfor'))
      let datainfor = {
        userNickname: rest ? rest.userName : '', // 微信昵称
        trueName: this.$store.state.userInfo.nickName, // 用户名
        phone: rest ? rest.mobilePhone : this.$store.state.userInfo.nickName // 手机号
      }
      datainfor.phone = datainfor.phone || '该客户未留手机号'
      localStorage.setItem('visitorinfor', JSON.stringify(datainfor))
      location.href = CustomerServiceLink
    },
  }
}
</script>

<style scoped lang="scss">
.main {
  position: relative;
  background-color: #fff;
  width: 100%;
  height: 100vh;
}

.user-banner {
  img {
    width: 100%;
  }
}

.user-info {
  position: relative;
  top: -10vw;
  margin: 0 10px;
  height: 118px;
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(106, 0, 0, 0.14);
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 17px 10px;
  .avatarIcon {
    width: 62px;
    height: 62px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .usernameText {
    font-size: 18px;
    height: 24px;
    line-height: 24px;
    font-weight: 400;
    color: #333330;
  }
  .nick-phone {
    flex: 1;
    .phone {
      margin-top: 5px;
    }
  }
  .edit {
    .editIcon {
      display: block;
      height: 24px;
    }
  }
}
.user-list {
  display: flex;
  flex-direction: column;
  margin: -15px 10px 20px 10px;
  .user-item {
    display: flex;
    justify-content: space-between;
    img {
      width: 170px;
      height: 81px;
    }
    margin-bottom: 10px;
  }
}
</style>
